import { Fetcher, objectToFormData } from '@this/src/util';
import React from 'react';
import _ from 'lodash';
import { TextField } from '../../shared/form_elements/form_elements';
import { createColors } from '../../shared/ui/theme/tokens/primitive-tokens/colors';
import { Link } from '@this/shared/ui/navigations/link';

const brandColors = createColors(1).brand;

interface Props {
  navigateToBack: () => void;
}
interface State {
  form: { email: string };
  result?: { type: UserPasswordResetFormResultType; message: string };
}
enum UserPasswordResetFormResultType {
  SUCCESS = 'success',
  FAIL = 'fail'
}
class PasswordResetForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { form: { email: '' } };
  }

  handleChange(value: string) {
    this.setState({ form: { email: value } });
  }

  async handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    this.setState({ result: undefined });
    try {
      const params = {
        'user[reset_email]': this.state.form.email
      };
      await Fetcher.post<{ redirect: string }>('/aiexpense/users/password', objectToFormData(params));
      this.setState({
        result: {
          type: UserPasswordResetFormResultType.SUCCESS,
          message: 'リセット用のリンクをメールで送信しました'
        },
        form: { email: '' }
      });
    } catch (e) {
      if (e.response.status === 400) {
        this.setState({
          result: {
            type: UserPasswordResetFormResultType.FAIL,
            message: e.response.data.errors
          }
        });
      } else {
        this.setState({
          result: {
            type: UserPasswordResetFormResultType.FAIL,
            message: '通信環境が不安定です。時間をおいてもう一度お試しください。'
          }
        });
      }
    }
  }

  get messageClassName(): string {
    if (!this.state.result) {
      return '';
    }

    return this.state.result.type === UserPasswordResetFormResultType.SUCCESS ? 'success' : 'error';
  }

  render() {
    const styles = getStyles();
    return (
      <div className="form-container">
        <form onSubmit={this.handleSubmit.bind(this)}>
          <TextField
            label="メールアドレス（必須）"
            value={this.state.form.email}
            example="例：yamada@aitravel.jp"
            onChange={value => this.handleChange(value)}
          />
          {!this.state.result || (
            <div className="expenses-users-signup__message">
              <p className={this.messageClassName}>{this.state.result.message}</p>
            </div>
          )}
          <button className="submit-button" type="submit" disabled={!this.state.form.email} style={styles.button}>
            パスワード再設定
          </button>
        </form>
        <div className="expenses-users-signup__utils" style={styles.utils}>
          <Link onClick={this.props.navigateToBack}>戻る</Link>
        </div>
      </div>
    );
  }
}

const getStyles = () => ({
  button: {
    backgroundColor: brandColors[500]
  },
  utils: {
    marginTop: '24px',
    fontWeight: 'normal' as const
  }
});

export default PasswordResetForm;
